import { usePopoverContext } from "@chakra-ui/react";
import React from "react";

interface PopoverTriggerProps {
  /**
   * The React child to use as the
   * trigger for the popover
   */
  children: React.ReactChild;
}

export const PopoverTrigger: React.FC<
  React.PropsWithChildren<PopoverTriggerProps>
> = (props) => {
  // enforce a single child
  const child: any = React.Children.only(props.children);
  const { getTriggerProps } = usePopoverContext();
  return React.cloneElement(child, getTriggerProps(child.props, child.ref));
};
